<template>
    <div class="v-card">
        <div class="v-card-header" key="excerpt">
            <div class="v-title">
                <img src="/images/app/quote-mark.svg" alt="quote icon" width="30" height="24" loading="lazy">
                <h3 class="v-title-text">{{ testimonial.title }}</h3>
            </div>
            <div class="v-content">
                <div class="v-content-text" v-html="testimonial.excerpt"></div>
            </div>
            <div class="v-footer">
                <p class="v-author">{{ testimonial.author }}<br>{{ testimonial.date }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            testimonial: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-card {
        display: flex;
        flex-flow: row wrap;
    }

    .v-card-header {
        width: 100%;
        flex-basis: 100%;
    }

    .v-title {
        margin-bottom: 1rem;
    }

    img {
        width: 30px;
    }

    .v-title-text {
        color: #474f59;
        font-size: 1.5rem;
    }

    .v-content-text {
        color: #474f59;
        font-size: inherit;
    }

    .v-author {
        margin-top: 1rem;
        color: #474f59;
    }

    .v-card-footer {
        display: flex;
        align-items: flex-end;
        margin-top: 1rem;
    }
</style>